'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$keys = _interopDefault(require('babel-runtime/core-js/object/keys'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var Waypoint = _interopDefault(require('waypoints'));
var PrettyScrollTo = _interopDefault(require('../global/scroll-to.js'));
var utils_js = require('../helpers/utils.js');

/**
 * Fixed to top navigation.
 *
 * @param {object} [options] optional configuration object
 * @param {$DOM element} [options.$container=$('.sticky-menu-container')] container of sticky nav (one level up).
 * @param {string} [options.classFixed='js-is-sticky-container'] class name added to $container once it meets page top or page top chrome (when you want it to start "sticking").
 * @param {string} [options.classAbs='js-is-abs-container']  class name added to $container once user has scrolled to bottom of page (when you want it to stop "sticking")
 * @param {string} [options.classLinkActive='js-is-active']  class name added to active links in nav
 * @param {number} [options.pageTopMargin=0]  offset in pixels between top of nav item and top of page
 * @param {number} [options.scrollOffset=0]  offset in pixels for the scrollTo position of each link
 * @class StickyNav
 * @namespace ShopifyMarketing
 * @constructor
*/
function StickyNav(options) {
  var config = {
    $container: $('.sticky-menu-container'),
    classFixed: 'js-is-sticky-container',
    classAbs: 'js-is-abs-container',
    classLinkActive: 'js-is-active',
    pageTopMargin: 0,
    scrollOffset: 0
  };

  this.options = _Object$assign({}, config, options);

  // Support passing a DOM node as 'container'
  if (this.options.container) {
    this.options.$container = $(this.options.container);
  }

  if (!this.options.$container.length) {
    return false;
  }

  this.init();
}

StickyNav.prototype.init = function () {
  var _this = this;

  this.menuDom = {
    $menu: this.options.$container.find('.sticky-menu'),
    $links: this.options.$container.find('.sticky-menu-link'),
    $waypoints: this.options.$container.find('.js-waypoint')
  };

  if (_Object$keys(this.menuDom).every(function (key) {
    return _this.menuDom[key].length;
  })) {
    this.getScrollLimits();

    // eslint-disable-next-line no-new
    this.prettyScroll = new PrettyScrollTo({
      offset: this.options.scrollOffset,
      $selector: this.menuDom.$links
    }, function (link) {
      _this.updateActiveLink($(link));
    });

    if (this._isMenuFits()) {
      this.options.$container.addClass('js-is-sticky-init');
      this.bindSticky();
      this.bindWaypoints();
    }
  }
};

/**
 * add active class name to currently active link
 * @method updateActiveLink
 * @param {$DOM element} el currently active link
*/
StickyNav.prototype.updateActiveLink = function (el) {
  var $el = utils_js.isJquery(el) ? el : $(el);
  var index = this.menuDom.$links.index($el);

  this.menuDom.$links.removeClass(this.options.classLinkActive);
  $el.addClass(this.options.classLinkActive);

  this.options.$container.trigger('change', index);
};

/**
 * Get values for scrollLimits object (page dimensions and layout)
 * @method  getScrollLimits
 * @return {object}
*/
StickyNav.prototype.getScrollLimits = function () {
  if ($('body').hasClass('js-modal-open')) {
    return {};
  }

  this.scrollLimits = {
    containerHeight: Math.round(this.options.$container.outerHeight()),
    menuTop: this.options.$container.offset().top - this.options.pageTopMargin,
    menuHeight: Math.round(this.menuDom.$menu.outerHeight()),
    viewHeight: Waypoint.viewportHeight()
  };

  return this.scrollLimits;
};

StickyNav.prototype._isMenuFits = function () {
  var limits = this.scrollLimits;

  return limits.menuHeight <= limits.viewHeight;
};

StickyNav.prototype._getPageOffsetTop = function () {
  return this.scrollLimits.menuTop;
};

StickyNav.prototype._getPageOffsetBottom = function () {
  return this.scrollLimits.containerHeight + this.scrollLimits.menuTop - this.scrollLimits.menuHeight;
};

StickyNav.prototype.updateStickyNav = function () {
  var $menuContainer = this.options.$container;
  var classFixed = this.options.classFixed;
  var classAbs = this.options.classAbs;
  var scrollTop = window.scrollY;

  if (scrollTop > this._getPageOffsetBottom()) {
    $menuContainer.addClass(classAbs);
    return;
  }

  if (scrollTop > this._getPageOffsetTop()) {
    $menuContainer.addClass(classFixed).removeClass(classAbs);
    return;
  }

  $menuContainer.removeClass(classAbs).removeClass(classFixed);
};

StickyNav.prototype.bindSticky = function () {
  var _this2 = this;

  var throttledUpdateNav = utils_js.throttle(function () {
    _this2.getScrollLimits();
    _this2.updateStickyNav();
  }, 100);

  $(window).on('scroll', this.updateStickyNav.bind(this)).on('resize', throttledUpdateNav).on('load', throttledUpdateNav);
};

StickyNav.prototype.bindWaypoints = function () {
  var _this3 = this;

  this.menuDom.$waypoints.each(function (index, waypoint) {
    // eslint-disable-next-line no-new
    new Waypoint({
      element: waypoint,
      handler: function handler() {
        if (!$(_this3.prettyScroll.options.scrollClass).length) {
          _this3.updateActiveLink(_this3.menuDom.$links.eq(index));
        }
      },
      offset: '20%'
    });
  });
};

module.exports = StickyNav;
